import { Dropdown } from 'antd'
import { useRouter } from 'next/router'
import React, { useRef } from 'react'
import styled from 'styled-components'
import { Link } from 'widgets'
import { useTranslation } from 'contexts/Localization'
import { MenuEntry } from './types'
import DropMenuText from './DropMenuText'

const WrapperMenuText = styled.header``

interface Props {
  menuItems: any
  refContainerDropdown: any
}

const Header: React.FC<Props> = ({ menuItems, refContainerDropdown }) => {
  const router = useRouter()
  const { t } = useTranslation()

  const paths = router.pathname.split('/').map((path) => `/${path}`)

  return (
    <>
      <WrapperMenuText>
        <ul className="menu-list">
          {menuItems.map((entry: any, index) => {
            const isActive = entry.actives.includes(paths[1])
            if (entry.items) {
              return (
                <DropMenuText
                  refContainerDropdown={refContainerDropdown}
                  key={entry.label}
                  entry={entry}
                  isActive={isActive}
                  paths={paths}
                />
              )
            }
            return (
              <li key={entry.label} className={paths.includes(entry.href || '') ? 'active' : ''}>
                <Link href={entry.href} target={entry.target}>
                  {typeof entry.label === 'string' ? t(entry.label) : entry.label}
                </Link>
              </li>
            )
          })}
        </ul>
      </WrapperMenuText>
    </>
  )
}

export default Header
